import { Link, useNavigate } from "react-router-dom";
import ShowSlider from "./ShowSlider";
import allbooks from "./slidingImage/allbooks.jpg";
import audiobook from "./slidingImage/audiobook.jpg"; 
import assignmentpic from "./otherImg/divineassignmentimg.jpg";
import dailyDevotion from "./otherImg/dailydevotion.jpg";
import { useEffect, useMemo, useRef, useState } from "react";
import { Button } from "@mui/material";
import { get, ref, query, limitToFirst} from "firebase/database";
import db, { realTimeDB } from "./firebase";
import ScrollingBook from "./newComponents/ScrollingBookContent";
import { HbrArrowLeft, HbrArrowOpenFile, HbrArrowRight, HbrEditIcon,HbrPauseIcon, HbrPlayButton, HbrTvIcon} from "./newComponents/Mycustomsvgicons";
import useFetch from "./useFetch";
import ScrollingAudioBoks from "./newComponents/ScrollingAudioBook";
import allbooksAvatar from "./otherImg/allbooksavatarhd.png";
import audiobooksAvatar from "./otherImg/audiobooksavatar.png";
import gsap from "gsap";
import ScrollTrigger from "react-scroll-trigger";
import DevotionListContent from "./DevotionListcontent";
import HomePreloaders from "./HomePreloaders";
import holinesstvimage from "./otherImg/holinesstvbanner.jpg";
import holinesstvback from "./otherImg/tvadbackground.png";
import ReactPlayer from "react-player";
import { collection, limit, orderBy, query as docQuery, getDocs } from "firebase/firestore";
import BlogContent from "./BlogContent";
import { PurifyTextUtils } from "./newComponents/GeneralClasses";
import DivineShorts from "./newComponents/DivineShorts";
import { ArrowForwardIos } from "@mui/icons-material";
import appIcon from "./otherImg/hbrlitenewicon.png";
import UseLayout from "./newComponents/useLayout";



const Navbar = () => {
    const [openBook, setOpenBook] = useState(false);
    const navigate = useNavigate();
    const [scrollingEngBooks,setScrollingEngBooks]=useState([]);
    const {data: audioBooksData,ispending,erroralert} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/audiobooks`);
    const {data: devotions ,ispendingDevotion,erroralertOnDevotion} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/dailydevotioneng`);
    const [isTempered,setIsTempered]=useState(false);
    const [isAudioTouch,setIsAudioTouch]=useState(false);
    const [posts,setPosts]=useState([]);
    const [audioBooks,setAudioBooks]=useState([]);
    const [shortvideos,setShortVideos]=useState([]);
    const [playing,setIsPlaying]=useState(false);
    const [assignmentInfo,setAssignmentInfo]=useState("");
    const [aboutTvInfo,setAboutTvInfo]=useState("");
    const scrollRef = useRef();
    const scrollAudioRef = useRef();
    const {width} = UseLayout();


    useEffect(()=>{
      async function getBookAnalytics() {
        if (audioBooksData) {
          const bookStatsSnapshot = await get(ref(realTimeDB,"audioBookStats"));
          const bookStatsData = bookStatsSnapshot.val();
  
          const arrayOfBooks = Object.keys(audioBooksData).map((key)=>({
            id: key,
  
            ...audioBooksData[key],
  
            stream: bookStatsData[PurifyTextUtils(audioBooksData[key].title)+" - Audio book 🎧"]?.stream ? bookStatsData[PurifyTextUtils(audioBooksData[key].title)+" - Audio book 🎧"].stream : 0,
  
            shares: bookStatsData[PurifyTextUtils(audioBooksData[key].title)+" - Audio book 🎧"]?.shares ? bookStatsData[PurifyTextUtils(audioBooksData[key].title)+" - Audio book 🎧"].shares : 0,
  
            downloads: bookStatsData[PurifyTextUtils(audioBooksData[key].title)+" - Audio book 🎧"]?.downloads ? bookStatsData[PurifyTextUtils(audioBooksData[key].title)+ " - Audio book 🎧"].downloads : 0,
  
            rate: bookStatsData[PurifyTextUtils(audioBooksData[key].title)+" - Audio book 🎧"]?.rate ? bookStatsData[PurifyTextUtils(audioBooksData[key].title)+" - Audio book 🎧"].rate : 0
          }));
    
          const sortedBooks = arrayOfBooks?.sort((a,b) => b.stream - a.stream);
          setAudioBooks(sortedBooks);
        }
      }
      getBookAnalytics();
  },[audioBooksData]);

  const memoizedAudioBooks = useMemo(()=>audioBooks, [audioBooks]);


    useEffect(()=>{
        if(!isTempered && scrollingEngBooks){
          const intervalId = setInterval(() => {
            if(scrollRef.current){
              if(scrollRef.current.scrollWidth - scrollRef.current.scrollLeft <= scrollRef.current.clientWidth){
                scrollRef.current.scrollLeft = 0;
              }else{
                scrollRef.current.scrollLeft += 1;
              }
            
            }
          }, 30);

          return()=>clearInterval(intervalId);
        }
    },[isTempered,scrollingEngBooks]);

    useEffect(()=>{
        if(!isAudioTouch && audioBooksData){
          const intervalId = setInterval(() => {
            if(scrollAudioRef.current){
              if(scrollAudioRef.current.scrollWidth - scrollAudioRef.current.scrollLeft <= scrollAudioRef.current.clientWidth){
                scrollAudioRef.current.scrollLeft = 0;
              }else{
                scrollAudioRef.current.scrollLeft += 1;
              }
            
            }
          }, 30);

          return()=>clearInterval(intervalId);
        }
    },[isAudioTouch,audioBooksData]);


    const handleScrollRight=()=>{
      setIsTempered(true);
      scrollRef.current.scrollLeft += 200;

      const timeid = setTimeout(() => {
        setIsTempered(false);
      }, 5000);
      return ()=>clearTimeout(timeid);
    };

    const handleScrollLeft=()=>{
      setIsTempered(true);
      scrollRef.current.scrollLeft += -200;

      const timeid = setTimeout(() => {
        setIsTempered(false);
      }, 5000);
      return ()=>clearTimeout(timeid);
    };

    const handleScrollAudioRIght=()=>{
      setIsAudioTouch(true);
      scrollAudioRef.current.scrollLeft += 200;

      const timeid = setTimeout(() => {
        setIsAudioTouch(false);
      }, 5000);
      return ()=>clearTimeout(timeid);
    };

    const handleScrollAudioLeft=()=>{
     setIsAudioTouch(true);
      scrollAudioRef.current.scrollLeft += -200;

      const timeid = setTimeout(() => {
        setIsAudioTouch(false);
      }, 5000);
      return ()=>clearTimeout(timeid);
    };

    const handleOnMouseOver=()=>setIsTempered(true);
    const handleOnMouseOut =()=>setIsTempered(false);
 
    const handleCancelOpenBook =()=>{
      setOpenBook(false);
     };

     useEffect(()=>{
      async function fetchBooks(){
        const bookStatsSnapshot = await get(ref(realTimeDB,"bookStats"));
        const engBooksSnapshot = await get(query(ref(realTimeDB,"Books english"), limitToFirst(70)));
        if(engBooksSnapshot.exists() && bookStatsSnapshot.exists()){
          const listOfBooks = engBooksSnapshot.val();
          const bookStatsData = bookStatsSnapshot.val();
  
          const arrayOfBooks = Object.keys(listOfBooks).map((key)=>({
            id: key,
  
            ...listOfBooks[key],
  
            reads: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.reads ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].reads : 0,
  
            shares: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.shares ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].shares : 0,
  
            bookmarks: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.bookmarks ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].bookmarks : 0,
  
            rate: bookStatsData[PurifyTextUtils(listOfBooks[key].name)]?.rate ? bookStatsData[PurifyTextUtils(listOfBooks[key].name)].rate : 0
          }));
    
          const sortedBooks = arrayOfBooks?.sort((a,b) => b.reads - a.reads);


          // const booksSubData = engBooksSnapshot.val();
          // const booksChildArray = Object.keys(booksSubData).map((key)=>({
          //     id: key,
          //     ...booksSubData[key]
          // }));
          setScrollingEngBooks(sortedBooks);
        }
      }
  
      async function fetchAssignement() {
        const assignment = await get(ref(realTimeDB,"Assignment/english url"));
        const aboutTvsnapshot = await get(ref(realTimeDB,"Banner/hbrTv/about tv"));
        if(assignment.exists()){
            setAssignmentInfo(assignment.val());
        }
        if (aboutTvsnapshot.exists()) {
          setAboutTvInfo(aboutTvsnapshot.val());
        }
      }

      fetchBooks();
      fetchAssignement();
     },[]);

     const memoizedBooks = useMemo(()=>scrollingEngBooks,[scrollingEngBooks]);
     const fetchedBooks = memoizedBooks || [];

    useEffect(()=>{
      const collectionref = collection(db,"Blog Posts");
      const q = docQuery(collectionref,orderBy('timestamp','desc'),limit(10));

      getDocs(q).then((snapshot)=>{
        const postItems = [];
          snapshot.forEach((doc)=>{
              postItems.push(doc.data());
          });
          setPosts(postItems);
      }).catch((err)=>{

      })
    },[]);
    const memoizedBlogPosts = useMemo(()=>posts,[posts]);

   useEffect(()=>{
    const collectionref = collection(db,"shorts");
    const q = query(collectionref,orderBy('timestamp','desc'),limit(15));
    getDocs(q).then((snapshot)=>{
      const shortVideos = [];
      snapshot.forEach((doc)=>{
          shortVideos.push(doc.data());
      });
     setShortVideos(shortVideos);
    }).catch((err)=>{
      console.log(err)
    });
   },[]);
   const memoizedshortvideos = useMemo(()=>shortvideos,[shortvideos]);


    //  const handleHighLatencyView=async()=>{
    //   const livebooleanvalue = await get(ref(realTimeDB,"Banner/hbrLiveSettings/live"));
    //   if (livebooleanvalue.val() === true) {
    //     const programTypesnapshot = await get(ref(realTimeDB,"Banner/hbrLiveSettings/programType"));
    //     navigate(`/hbrlive?watch=${programTypesnapshot.val()}`);
    //   }else{
    //     dispatch({type: actionConsts.SHOWALERT, payload: true});
    //   }
    //   dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Service not available. Use the low latency option"});
    //   dispatch({type: actionConsts.SHOWALERT, payload: true});
    
    //  };

    
    //  const handleLowLatencyView=async()=>{
    //   const livebooleanvalue = await get(ref(realTimeDB,"Banner/hbrLiveSettings/live"));
    //   if (livebooleanvalue.val() === true) {
    //     const programTypesnapshot = await get(ref(realTimeDB,"Banner/hbrLiveSettings/programType"));
    //     navigate(`/hbrlivev2?watch=${programTypesnapshot.val()}`);
    //   }else{
    //     dispatch({type: actionConsts.SHOWALERT, payload: true});
    //   }
      
    //  };



    return ( 
       <div className="navbar">

          <ShowSlider/>

          <div className="navcontainer" >
                    <div className="flex-row2" style={{position:"absolute",top:"7%",width:"100%"}}>
                      <div className="flex-row2" style={{width:"200px", borderRadius:"10px",backgroundColor:"white",boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.   19), 0px 6px 6px rgba(0, 0, 0, 0.23)",boxSizing:"border-box",padding:"10px",zIndex:"1",cursor:"pointer"}} onClick={()=>navigate("/holinesstv")}>
                        <h2 style={{color:"black"}}>Watch Tv</h2>
                          <HbrTvIcon width="1.7em" height="1.7em" fillColour="#eb268f" />
                      </div>
                    </div>
                    
                    <ScrollTrigger onEnter={()=>gsap.fromTo('#tvcommercialhomeanimate',
                    {x:100,opacity:0},{x:0,opacity:1,duration:3})} className="scrolltrigger" >
                      <div id="tvcommercialhomeanimate" className="tvcommercialonhomepage" >
                     
                        <div style={{width:"100%",height:"100%",position:"relative",borderRadius:"10px",background:"#101010"}}>
                            {playing && 
                               <div className="pausetvvommercialonhome flex-row2" onClick={()=>setIsPlaying(false)}>
                               <HbrPauseIcon  width="2em" height="2em" fillColour="white"/>
                             </div>
                            }
                            {!playing && 
                                <div className="starttvvommercialonhome flex-row2" onClick={()=>setIsPlaying(true)}>
                                <HbrPlayButton  width="2em" height="2em" fillColour="white"/>
                              </div>
                            }
                       
                           {/* {playing && <div className="playeroverlay"></div>}  */}
                           <div className="playeroverlay"></div>
                            <ReactPlayer
                              url={"https://youtu.be/wMxDRzij-og"}
                              playing={playing}
                              loop
                              width={"100%"}
                              height={"100%"}
                              config={{
                                  youtube:{
                                      playerVars:{
                                          modestbranding:1,
                                          controls:0,
                                          showinfo:0,
                                      }
                                  }
                              }}
                           />
                        </div>

                     </div>

                    </ScrollTrigger>
          
                    <ScrollTrigger onEnter={()=>gsap.fromTo('#holinesstvlogohomedisplay',
                    {x:100,opacity:0},{x:0,opacity:1,duration:3})} className="scrolltrigger" >
                      <img id="holinesstvlogohomedisplay" src={holinesstvimage} alt=""/>
                    </ScrollTrigger>
                   

                    <ScrollTrigger onEnter={()=>gsap.fromTo('#tvbackhomedisplay',
                    {x:100,opacity:0},{x:0,opacity:1,duration:3})} className="scrolltrigger" >
                      <div style={{width:"100%",height:"600px"}}>
                      <img id="tvbackhomedisplay" src={holinesstvback} alt= "" style={{
                      width:"100%",
                      height:"100%",
                      objectFit:"cover"
                      }}/>
                      </div>
                    </ScrollTrigger>
            
                
                    <div className="abouttvhomedisplaydiv" style={{width:"80%",height:"auto",zIndex:"1",background:"#101010",borderRadius:"10px",position:"absolute",padding:"10px"}}>
                        <ScrollTrigger onEnter={()=>gsap.fromTo('#abouttvtext',
                          {y:100,opacity:0},{y:0,opacity:1,duration:3})} className="scrolltrigger">
                              <pre id="abouttvtext" style={{color:"white", fontWeight:"bold",whiteSpace:"pre-wrap"}}>
                                {aboutTvInfo && aboutTvInfo}
                              </pre>
                      </ScrollTrigger>
                  </div>
           </div>


          <div className="navcontainer" >
                <div className="flex-column1" style={{height:"100%",width:"100%"}}>
                    <h3 id="allBooksTitle">All Books</h3>
                    <img src={allbooks} alt= "All books component." 
                    style={{width:'100%',height:"100%",objectFit:"cover"}}/>
                </div>

             
                <ScrollTrigger onEnter={()=> gsap.fromTo("#allbooksavatar",
                  {x:150,opacity:0},{x:0,opacity:1,duration:3})}>
                <img src={allbooksAvatar} id="allbooksavatar" alt=""
                  />
                </ScrollTrigger>
              

                <div className="flex-row2" style={{position:"absolute",top:"45%",left:"1em",zIndex:"2",backgroundColor:"#00000050", borderRadius:"10px",padding:"5px"}}>
                  <h4 style={{color:"white",fontWeight:"bolder"}}>Most read books</h4>
                </div>

              <div className="scrollingbooksdivmarquee" ref={scrollRef}
                    onMouseOver={handleOnMouseOver}
                    onMouseOut={handleOnMouseOut}>
                    {fetchedBooks && fetchedBooks.map((book) =>(
                      <ScrollingBook 
                        key={book.id}
                        name={book.name}
                        webid={book.webid}
                        bookcover={book.bookcover}
                        authorpic={book.authorpic}
                        summary={book.summary}
                        reads={book.reads}
                      />
                  ))}
                  {!fetchedBooks && <HomePreloaders actionshare={"show"} actionPic={"show"} height={"100%"}/>}
              </div>

              <ScrollTrigger onEnter={()=>gsap.fromTo('#allbooksmoremenu',{y:20,opacity:0},{y:0,opacity:1,duration:5,ease:'bounce.inOut'})}>
                    <div id="allbooksmoremenu" className="allbooksmoremenu flex-row2" style={{gap:"10px",position:"absolute",top:"20%",zIndex:"2"}}>
                      <h2 style={{color:"white",fontWeight:"bolder", backgroundColor:"#00000050", borderRadius:"10px",padding:"5px"}}>Discover More Books</h2>
                    
                      <div className="arrowopenfile" style={{borderRadius:"50%",cursor:"pointer",backgroundColor:"#1C1F2E80",padding:"10px"}}>
                        <HbrArrowOpenFile width="2.5em" height="2.5em" fillColour="#FFFFFF" handleClick={()=>setOpenBook(prev => !prev)}/>
                      </div>

                        {openBook && 
                              <section className="showAlertDialog" >
                                  <div className="alert-footer flex-column1">
                                  <Link to="/hrmwenglishbooks" >English Books</Link> <br/><br/>
                                  <h3>Translation into other languages are underway</h3> <br/>
                                  {/* <Link to="/hrmwfrenchbooks" >French Books</Link> <br/><br/>
                                  <Link to="/hrmwgermanbooks" >German Books</Link> <br/><br/>
                                  <Link to="/hrmwspanishbooks" >Spanish Books</Link> <br/><br/>
                                  <Link to="/hrmwhindibooks" >Hindi Books</Link> <br/><br/>
                                  <Link to="/hrmwfilipinobooks" >Filipino Books</Link> <br/><br/> */}
                                </div>
                                <Button onClick={handleCancelOpenBook}>Cancel</Button>
                            </section>
                        }
                
                    </div>
                </ScrollTrigger>

              <div className="flex-row2" style={{position:"absolute",top:'95%',left:"45%",zIndex:"2"}}>
                    <div style={{borderRadius:"50%",cursor:"pointer",backgroundColor:"#1C1F2E80"}}>
                          <HbrArrowLeft width="1.7em" height="1.7em" fillColour="#ffffff" handleClick={handleScrollLeft}/>
                    </div>

                    <div style={{borderRadius:"50%",cursor:"pointer",backgroundColor:"#1C1F2E80"}}>
                        <HbrArrowRight width="1.7em" height="1.7em" fillColour="#ffffff" handleClick={handleScrollRight}/>
                    </div>
              </div>

          </div>   


          <div className="navcontainer" >
                <div className="flex-column1" style={{height: "100%",width:"100%"}}>
                    <h2>Audio Books</h2>
                    <img  src={audiobook} alt= "Audio Book Logo" style={{
                      width:"100%",
                      height:"100%",
                      objectFit: "cover"
                    }}/>
                </div>
                
                <ScrollTrigger onEnter={()=>gsap.fromTo('#audiobooksMoremenu',{y:20,opacity:0},{y:0,opacity:1,duration:5,ease:'bounce.inOut'})}>
                <div id="audiobooksMoremenu" className="audiobooksMoremenu flex-row2" style={{gap:"10px",position:"absolute",top:"20%",zIndex:"2"}}>
                    <h2 style={{color:"white",fontWeight:"bolder", backgroundColor:"#00000050", borderRadius:"10px"}}>More AudioBooks</h2>
                  
                    <div className="arrowopenfile" style={{borderRadius:"50%",cursor:"pointer",backgroundColor:"#1C1F2E80",padding:"10px"}}>
                      <HbrArrowOpenFile width="2.5em" height="2.5em" fillColour="#FFFFFF" handleClick={()=>navigate("/audioBooks")}/>
                    </div>
                </div>
                </ScrollTrigger>
          


                <ScrollTrigger onEnter={()=> gsap.fromTo('#allbooksavatar',
                  {x:0,opacity:0},{x:150,opacity:1,duration:3,yoyo:true})}>
                <img src={audiobooksAvatar} id="allbooksavatar" alt=""/>
                </ScrollTrigger>
              

                <div className="flex-row2" style={{position:"absolute",top:"45%",left:"1em",zIndex:"2",backgroundColor:"#10101050"}}>
                  <h4 style={{color:"white",fontWeight:"bolder"}}>Most streamed</h4>
                </div>

                <div className="scrollingbooksdivmarquee" ref={scrollAudioRef}
                  onMouseOver={()=>setIsAudioTouch(true)}
                  onMouseOut={()=>setIsAudioTouch(false)}>
                      
                      {memoizedAudioBooks && memoizedAudioBooks.map((data)=>(
                          <ScrollingAudioBoks 
                            key={data._id}
                            audioID={data._id}
                            image={data.image}
                            title={data.title}
                            stream={data.stream}
                          />
                      ))}
                      {ispending && <HomePreloaders actionshare={""} actionPic={""}/>}
                      {erroralert && <p>Failed to access audiobooks</p>}
                </div>

                <div className="flex-row2" style={{position:"absolute",top:'90%',left:"45%",zIndex:"2"}}>
                    <div style={{borderRadius:"50%",cursor:"pointer",backgroundColor:"#1C1F2E80"}}>
                          <HbrArrowLeft width="1.7em" height="1.7em" fillColour="#ffffff" handleClick={handleScrollAudioLeft}/>
                    </div>

                    <div style={{borderRadius:"50%",cursor:"pointer",backgroundColor:"#1C1F2E80"}}>
                        <HbrArrowRight width="1.7em" height="1.7em" fillColour="#ffffff" handleClick={handleScrollAudioRIght}/>
                    </div>
                </div>
        
          </div>


          <div className="navcontainer">

                <ScrollTrigger onEnter={()=>gsap.fromTo('#devotiongsap',{y:100,opacity:0},{y:0,opacity:1,duration:3})} className="scrolltrigger" >
                <div id="devotiongsap" className="flex-column1" style={{height: "100%",width:"100%"}}>
                
                    <h3>Daily Devotion</h3>
                    <img src={dailyDevotion} alt= "Daily Devotion" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
            
                </div>
                </ScrollTrigger>
          
                
                <div className="quickaccessdevotion">
                    {devotions && devotions.map((data) =>(
                          <DevotionListContent
                              key={data._id}
                              bookid={data._id}
                              title={data.title}
                              image={data.image}
                          />
                    ))}
                    {ispendingDevotion && <HomePreloaders actionshare={"show"} actionPic={""}/>}
                    {erroralertOnDevotion && <p>Failed to fetch daily devotions</p>}
                    
                </div>
        </div>

        <div className="navcontainer" style={{height:"auto",marginTop:"4em"}} >
                <div className="flex-row2">
                    <h2>Divine Assignment</h2>
                    <button onClick={()=>navigate("/assignment record")}
                        style={{border:"none",borderRadius:"10px",padding:"5px",color:"white",fontWeight:"bold",backgroundColor:"#0E78F9",cursor:"pointer"}}>
                      Keep Record 
                      <HbrEditIcon width="1.6em" height="1.6em" fillColour="#ffffff"/>
                    </button>
                </div>
                

                <ScrollTrigger onEnter={()=>gsap.fromTo('#assignmentinfofronticon',
                {x:100,opacity:0},{x:0,opacity:1,duration:3})} className="scrolltrigger" >
                            <img id="assignmentinfofronticon" src={assignmentpic} alt= "" style={{
                  width:"50%",
                  height:"50%",
                  position:"absolute",
                  zIndex:"0",
                  right:"10px",
                  top:"20%",
                  objectFit:"contain"
                  }}/>
                </ScrollTrigger>
        
            
            
                    <div style={{width:"100%",height:"100%",zIndex:"1"}}>
                        <ScrollTrigger onEnter={()=>gsap.fromTo('#assignmentinfofrontpage',
                          {y:100,opacity:0},{y:0,opacity:1,duration:3})} className="scrolltrigger">
                              <pre id="assignmentinfofrontpage" style={{width:"auto",maxWidth:"90%",color:"black", fontWeight:"bold",whiteSpace:"pre-wrap"}}>
                                {assignmentInfo && assignmentInfo.replace(/\*\*/g,"\n")}
                              </pre>
                      </ScrollTrigger>
                  </div>
            
      
        </div>
          
          <div className={`socialviewhomepage ${width <= 1024 ? 'mobile':'desktop'}`} style={{width:"100%"}}>
            
                <div className={`shortvideosHome flex-row2 ${width <= 1024 ? 'mobile':'desktop'}`}>
                    
                    {memoizedshortvideos && memoizedshortvideos.map((data,index)=>(
                        <DivineShorts
                        key={index}
                        shorts_email={data.shorts_email}
                        shorts_thumbnail={data.shorts_thumbnail}
                        index={index}
                        shorts_id={data.shorts_id}
                        timestamp={data.timestamp}
                        />
                    ))}

                    <div className="flex-column1" onClick={() => navigate("/divineblogs")} style={{width: "150px", height:"200px", borderRadius:"10px", marginTop:"10px", gap:"10px",cursor:"pointer", 
                      boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)"}}>
                      <img src={appIcon} alt="" style={{width:"100%", height:"40%", objectFit:"cover"}}/>
                      <ArrowForwardIos/>
                      <h4>More Videos</h4>
                    </div>
                </div>

              <div className="blogcollectionhome">
                    {memoizedBlogPosts && memoizedBlogPosts.map((post)=>(
                        <BlogContent
                            key={post.timestamp}
                            postID ={post.postID}
                            blog_message = {post.blog_message}
                            blogger_email = {post.blogger_email}
                            blog_date = {post.blog_date}
                            blogger_name = {post.blogger_name}
                            blogger_profile_pic = {post.blogger_profile_pic}
                            videolink = {post.video_url}
                            video_thumb={post.video_thumb}
                            images={post.images}
                            edifiedby = {post.edifiedby}
                            timestamp = {post.timestamp}
                            bloggerpageid={post.bloggerpageid}
                        />
                    ))}
                    <button style={{border:"none",padding:"10px", fontWeight:"bold", marginTop:"20dp", cursor:"pointer"}}
                            onClick={() => navigate("/divineblogs")}>
                      Load more contents...
                    </button>
              </div>
          </div>

        <br/> <br/>

        <div className="owners">
            <p>Copyright 2025 - Horemow Book Reader Web App | bethelSoftware | All Rights Reserved</p> 
        </div>
      </div>
     );
}
export default Navbar;